import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastService } from 'app/shared/toast.service';
import { DialogService } from '@progress/kendo-angular-dialog';
import { CategoryNotificationService } from './category-notification.service';
import { CategoryNotification, Notification } from './categoty-notification.model';
import { SfhSecurityService } from '@sasser/sfh-shared-security';
import { BaseFormComponent } from '../base-form-component/base-form.component';
import { Router } from '@angular/router';

@Component({
  selector: 'category-notification',
  templateUrl: 'category-notification.component.html',
})


export class CategoryNotificationComponent implements OnInit{
  formName = 'notificationForm';
	@ViewChild('notificationForm') public mainForm: NgForm;
  categoriesList : CategoryNotification[]=[];
  initialuserNotificationList: Notification[]=[];
  initialuserNotificationIdsList: number[]=[];
  userNotificationList : Notification[]=[];
  userNotificationIdsList : number[]=[];
  pageLoading : boolean;
  nightMode = true;
  userEmail: any;
  
  constructor(private categoryNotificationService: CategoryNotificationService,
    private toastr: ToastService,
    public sfhAuth: SfhSecurityService,
     private router: Router) { 
  }

  ngOnInit(): void {
    this.userEmail = this.sfhAuth.userInfo.email;
    this.getUserCategoryNotification();
  }

  getUserCategoryNotification(){
    this.pageLoading = true;
    this.categoryNotificationService.getUserCategoryNotification(this.userEmail).subscribe(userNotification=>{      
      this.initialuserNotificationList = userNotification;  
      this.initialuserNotificationIdsList = this.initialuserNotificationList.map(x => x.id);
      this.userNotificationList = Object.assign([],this.initialuserNotificationList);            
      this.userNotificationIdsList = this.userNotificationList.map(x => x.id);
      this.getAllCategories();
    },error=>{
      this.pageLoading = false;
      this.toastr.error(error, 'Error');				
    });
  }

  getAllCategories(){
    this.categoryNotificationService.getAll().subscribe(categories=>{      
      this.categoriesList = categories;
      this.pageLoading = false;
    },error=>{
      this.pageLoading = false;
      this.toastr.error(error, 'Error');				
    });
  }

  checkSubNotifications(category : CategoryNotification): boolean{
    let checkAll=true;
    if(category.notificationCategory.length>0){
      category.notificationCategory.forEach(item => {
        if(!this.userNotificationIdsList.includes(item.notification.id)){
          checkAll = false;
        }
      });
      return checkAll;
    }
    return false;
  }

  onCategoryclick(event:any, Category : CategoryNotification){
    if(event.target.checked){
      Category.notificationCategory?.forEach(item => {
        this.userNotificationList.push(item.notification);
        this.userNotificationIdsList.push(item.notification.id);
      });      
    }
    else if(!event.target.checked){
      Category.notificationCategory?.forEach(item => {
        let index = this.userNotificationList.findIndex(x => x.id==item.notification.id);
        if(index >= 0){
          this.userNotificationList.splice(index,1);
          let idx = this.userNotificationIdsList.findIndex(x => x==item.notification.id);
          this.userNotificationIdsList.splice(idx,1);
        }  
      });          
    }    
  }

  onNotificationCheckboxclick(event:any, notification : Notification){
    if(event.target.checked){
      this.userNotificationList.push(notification);
      this.userNotificationIdsList.push(notification.id);
    }
    else if(!event.target.checked){
      let index = this.userNotificationList.findIndex(x => x.id==notification.id);
      if(index >= 0){
        this.userNotificationList.splice(index,1);
        let idx = this.userNotificationIdsList.findIndex(x => x==notification.id);
        this.userNotificationIdsList.splice(idx,1);
      }      
    }    
  }

  saveUserNotificationList(){      
    this.pageLoading = true;
    this.categoryNotificationService.saveUserNotificationList(this.userEmail,this.userNotificationList).subscribe(userNotification =>{ 
      if(userNotification){
        this.toastr.success('User categories saved successfully!','Success');
        this.toastr.info('Notifications will be displayed based on the selected categories.','Notifications Updated', { positionClass: 'toast-bottom-left' })
        this.initialuserNotificationList = userNotification;  
        this.initialuserNotificationIdsList = this.initialuserNotificationList.map(x => x.id);
        this.userNotificationList = Object.assign([],userNotification);            
        this.userNotificationIdsList = this.userNotificationList.map(x => x.id);
        this.pageLoading = false;
      }
    }, error => {
      this.pageLoading = false;
      this.toastr.error(error, 'Error');				
    });

  }

  resetData(){
    this.userNotificationList = Object.assign([],this.initialuserNotificationList);            
    this.userNotificationIdsList = this.userNotificationList.map(x => x.id);
    this.router.navigate(['/starterview']);
  }

}
